export default {
  withdraw: {
    title: 'ถอนเงิน',
    subtitle: 'รวดเร็ว ปลอดภัย และสะดวก',
    secureEncrypted: 'ปลอดภัยและเข้ารหัส',
    fiatOrCash: 'เงินตรา/เงินสด',
    processing: 'กำลังดำเนินการ...',
    select: 'เลือก',
    withdrawCurrency: 'สกุลเงินที่ถอน',
    chooseNetwork: 'เลือกเครือข่าย',
    channel: 'ช่องทาง',
    withdrawalAddress: 'ที่อยู่การถอน',
    pixKeyType: 'ประเภทคีย์ PIX',
    accountNumber: 'เลขที่บัญชี',
    enterAccountNumber: 'กรุณากรอกเลขที่บัญชีของคุณ',
    accountName: 'ชื่อบัญชี',
    enterAccountName: 'กรุณากรอกชื่อเจ้าของบัญชี',
    pixKey: 'คีย์ PIX',
    enterPixKey: 'กรุณากรอกคีย์ PIX ของคุณ',
    cpf: 'CPF',
    enterCpf: 'กรุณากรอก CPF',
    bankName: 'ชื่อธนาคาร',
    enterBankName: 'กรุณากรอกชื่อธนาคาร',
    branch: 'สาขา',
    enterBranch: 'กรุณากรอกสาขา (ไม่บังคับ)',
    phone: 'โทรศัพท์',
    enterPhone: 'กรุณากรอกเบอร์โทรศัพท์ (ไม่บังคับ)',
    email: 'อีเมล',
    enterEmail: 'กรุณากรอกอีเมล (ไม่บังคับ)',
    available: 'ถอนได้',
    amountPlaceholder: 'จำนวนเงิน ({unit})',
    min: 'ต่ำสุด',
    max: 'สูงสุด',
    totalWithdrawalAmount: 'จำนวนเงินถอนทั้งหมด:',
    fee: 'ค่าธรรมเนียม:',
    withdrawalAmount: 'จำนวนเงินที่ได้รับ:',
    fundsSafeTitle: 'เงินของคุณปลอดภัยกับเรา',
    fundsSafeDesc: 'เราใช้ระบบความปลอดภัยชั้นนำเพื่อปกป้องธุรกรรมและข้อมูลส่วนตัวของคุณ',
    enterWithdrawalAddress: 'กรุณากรอกที่อยู่การถอน',
    enterAccountNumberRequired: 'กรุณากรอกเลขที่บัญชีของคุณ',
    selectChannelRequired: 'กรุณาเลือกช่องทาง',
    enterAccountNameRequired: 'กรุณากรอกชื่อเจ้าของบัญชี',
    selectPixKeyTypeRequired: 'กรุณาเลือกประเภทคีย์ PIX',
    enterCpfRequired: 'กรุณากรอก CPF',
    enterValidAmount: 'กรุณากรอกจำนวนเงินที่ถูกต้อง',
    minWithdrawal: 'ถอนขั้นต่ำ: {amount} {unit}',
    maxWithdrawal: 'ถอนสูงสุด: {amount} {unit}',
    insufficientBalance: 'ยอดเงินที่ใช้ได้ไม่เพียงพอ',
    withdrawalRejected: 'การถอนถูกปฏิเสธ',
    submittedPendingReview: 'ส่งคำขอถอนแล้ว รอการตรวจสอบ',
    submittedPayoutInProgress: 'ส่งคำขอถอนแล้ว กำลังดำเนินการจ่ายเงิน',
    withdrawalFailed: 'การถอนล้มเหลว',
    withdrawalFailedRetry: 'การถอนล้มเหลว กรุณาลองใหม่อีกครั้ง',
  },
};
